import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sitemap-issues-table',
  templateUrl: './sitemap-issues-table.component.html',
  styleUrls: ['./sitemap-issues-table.component.css']
})
export class SitemapIssuesTableComponent {
  @Input() issues: any[] = [];

  getPriorityClass(priority: string) {
    switch (priority) {
      case 'P0': return 'badge badge-danger';
      case 'P1': return 'badge badge-warning';
      case 'P2': return 'badge badge-info';
      default: return 'badge badge-secondary';
    }
  }
}
